import { useEffect } from "react"

declare global {
  interface Window {
    ss_open_profile?: () => void
  }
}

/**
 * GMO グローバルサインのサイトシール。
 * @see https://jp.globalsign.com/ssl/guide/siteseal.html
 *
 * 公式サンプルは `window.addEventListener('load', ...)` でスクリプトを挿入するが、
 * Next.js の SPA 遷移では `load` が再発火しないため、マウント毎に script 要素を動的追加する。
 * アンマウント時は追加した script を除去し、DOM に蓄積しないようにする。
 */
const GlobalSign = () => {
  useEffect(() => {
    const s = document.createElement("script")
    s.src = "https://seal.atlas.globalsign.com/gss/one/seal?image=seal_100-50_ja.png"
    document.body.appendChild(s)
    return () => {
      s.remove()
    }
  }, [])

  const openProfile = () => {
    if (window.ss_open_profile) window.ss_open_profile()
  }

  return (
    <div
      id="ss_gmo_globalsign_secured_site_seal"
      onContextMenu={(e) => e.preventDefault()}
      style={{ width: "100px", height: "50px", padding: 0 }}
    >
      <button
        type="button"
        onClick={openProfile}
        style={{
          padding: 0,
          border: 0,
          background: "transparent",
          cursor: "pointer",
          width: "100%",
          display: "block",
        }}
      >
        <img
          id="ss_gmo_globalsign_img"
          src="data:image/gif;base64,R0lGODlhAQABAGAAACH5BAEKAP8ALAAAAAABAAEAAAgEAP8FBAA7"
          alt="SSL　GMOグローバルサインのサイトシール"
          style={{ border: 0, width: "100%", display: "block" }}
        />
      </button>
    </div>
  )
}

export default GlobalSign
